import type { FrontendWidget } from '../types';
import { ContactWidgetComponent } from './ContactWidgetComponent';
import { ContactWidgetComponentB } from './ContactWidgetComponentB';
import { ContactWidgetComponentC } from './ContactWidgetComponentC';
import type { ContactWidgetConfig, ContactWidgetResolved } from './types';

export const contactWidget: FrontendWidget<
  ContactWidgetConfig,
  ContactWidgetResolved
> = {
  componentType: 'widgets.contact-widget',
  displayName: 'Contact Widget',
  ComponentA: ContactWidgetComponent,
  ComponentB: ContactWidgetComponentB,
  ComponentC: ContactWidgetComponentC,
  resolveSync: (config) => config,
};
